export const EDUCATOR_REVOKE = 'EDUCATOR_REVOKE';
export const EDUCATOR_SET_PENDING = 'EDUCATOR_SET_PENDING';
export const EDUCATOR_SET_SESSION = 'EDUCATOR_SET_SESSION';
export const EDUCATOR_SET_SESSIONS = 'EDUCATOR_SET_SESSIONS';
export const EDUCATOR_DELETE_SESSION = 'EDUCATOR_DELETE_SESSION';
export const EDUCATOR_SET_SESSION_DOCUMENTS = 'EDUCATOR_SET_SESSION_DOCUMENTS';
export const EDUCATOR_STUDENT_UPDATE_DOCUMENT = 'EDUCATOR_STUDENT_UPDATE_DOCUMENT';
